import React from 'react'
import { Link } from 'react-router-dom'
import Navbar from '../components/navbar'
import hero from '../assets/images/hero/directorio.jpg'
import Footer from '../components/footer'
import ScrollToTop from '../components/scroll-to-top'
import Directorioall from '../components/directorioall'
import { Helmet } from 'react-helmet-async'
import { useState, useEffect } from 'react';
import useCsrfToken from '../hooks/useCsrfToken'

export default function Directorio() {
    const { csrfToken } = useCsrfToken();
    const basedomain = process.env.REACT_APP_BASE_URL;
    const [directoryfile, setDirectoryfile] = useState([]);

    useEffect(() => {
        const API_URL = process.env.REACT_APP_API_URL;
        const transformData = (data) => {
            console.log('data', data);
            return [{
                title: data.title,
                directory_file: data.directory_file ? `${API_URL}/storage/${data.directory_file}` : null,
            }];
        };
        if (csrfToken != null) {
            fetch(`${API_URL}/api/get-directory-file`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                }
            }).then(response => response.json())
                .then(data => {
                    // console.log('data1', data);
                    setDirectoryfile(transformData(data))
                })
                .catch(error => console.error('Error fetching file:', error));
        }
    }, [csrfToken]);

    return (
        <>
            <Helmet>
                <title>Directorio Médico | Hospital Aranda de La Parra</title>
                <meta name="description" content="Encuentra a los especialistas que conforman nuestro equipo, comprometidos con brindar atención médica de alta calidad." />
                <meta property="og:title" content="Directorio Médico | Hospital Aranda de La Parra" />
                <meta property="og:description" content="Encuentra a los especialistas que conforman nuestro equipo, comprometidos con brindar atención médica de alta calidad." />
                <meta property="og:image" content={`${basedomain}${hero}`} />
                <meta property="og:url" content={`${basedomain}/directorio`} />
                <meta property="og:type" content="website" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Directorio Médico | Hospital Aranda de La Parra" />
                <meta name="twitter:description" content="Encuentra a los especialistas que conforman nuestro equipo, comprometidos con brindar atención médica de alta calidad." />
                <meta name="twitter:image" content={`${basedomain}${hero}`} />
                <meta itemprop="name" content="Directorio Médico | Hospital Aranda de La Parra" />
                <meta itemprop="description" content="Encuentra a los especialistas que conforman nuestro equipo, comprometidos con brindar atención médica de alta calidad." />
                <meta itemprop="image" content={`${basedomain}${hero}`} />
            </Helmet>
            <Navbar />

            <section className="bg-half-170 d-table w-100" style={{ backgroundImage: `url(${hero})`, backgroundPosition: 'center' }}>
                <div className="bg-overlay bg-gradient-overlay"></div>
                <div className="container">
                    <div className="row mt-5 justify-content-center">
                        <div className="col-12">
                            <div className="title-heading text-center">
                                <h5 className="heading fw-semibold mb-0 sub-heading text-white title-dark">Directorio Médico</h5>
                            </div>
                        </div>
                    </div>

                    <div className="position-middle-bottom">
                        <nav aria-label="breadcrumb" className="d-block">
                            <ul className="breadcrumb breadcrumb-muted mb-0 p-0">
                                <li className="breadcrumb-item"><Link to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Directorio</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </section>
            <div className="position-relative">
                <div className="shape overflow-hidden text-white">
                    <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
                    </svg>
                </div>
            </div>

            <section className="section">
                <div className="container mt-50 mt-60">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="section-title text-center mb-4 pb-2">
                                <h4 className="title mb-3">Directorio Médico</h4>

                                <p className="text-muted para-desc mx-auto mb-0">
                                    Encuentra a los especialistas que conforman nuestro equipo, comprometidos con brindar atención médica de alta calidad. Cada profesional trabaja con un enfoque humano, ético y actualizado para garantizar el bienestar de nuestros pacientes. Explora nuestra lista de médicos y encuentra al experto que mejor se adapte a tus necesidades de salud.
                                </p>

                            </div>
                        </div>
                    </div>
                    <div className="row justify-content-center mb-5">
                        <div className="col-sm-6 col-12 text-center">
                            <div className="d-flex flex-wrap justify-content-center gap-2">
                                {directoryfile.length > 0 && directoryfile[0].directory_file != null &&
                                    (
                                        <Link
                                            to={directoryfile[0].directory_file}
                                            target="_blank"
                                            className="btn btn-success btn-sm text-light hv:bg-secondary"
                                        >
                                            Descargar directorio <i className="mdi mdi-chevron-right align-middle"></i>
                                        </Link>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                    <Directorioall />
                </div>
            </section>

            <Footer />

            <ScrollToTop />
        </>
    )
}
